import { useCallback, useEffect, useState, type ReactNode } from 'react';
import { useEnvio } from '../../application/dependencias';

// Peças comuns das seções das Configurações: campo de texto, grupo de campos e carga com erro.

type PropsCampo = {
  rotulo: string;
  valor: string | number | null | undefined;
  definir: (valor: string) => void;
  tipo?: 'text' | 'email' | 'number' | 'date' | 'url' | 'tel';
  dica?: string;
  largura?: 'curta' | 'media' | 'longa';
  somenteLeitura?: boolean;
};

export function CampoConfig({ rotulo, valor, definir, tipo = 'text', dica, largura = 'media', somenteLeitura }: PropsCampo) {
  return (
    <label className={`campo config__campo config__campo--${largura}`}>
      <span>{rotulo}</span>
      <input type={tipo} value={valor ?? ''} readOnly={somenteLeitura} onChange={(e) => definir(e.target.value)} />
      {dica && <small>{dica}</small>}
    </label>
  );
}

export function Grupo({ titulo, children, acoes }: { titulo: string; children: ReactNode; acoes?: ReactNode }) {
  return (
    <fieldset className="config__grupo">
      <legend>{titulo}</legend>
      <div className="config__campos">{children}</div>
      {acoes && <div className="config__grupo-acoes">{acoes}</div>}
    </fieldset>
  );
}

/** Carrega os dados da seção e devolve `recarregar`; erro de carga aparece no lugar do conteúdo. */
export function useCarga<T>(carregar: () => Promise<T>) {
  const [dados, definir] = useState<T | null>(null);
  const [erro, definirErro] = useState<string>();
  const recarregar = useCallback(() => carregar().then(definir, (e: Error) => definirErro(e.message)), [carregar]);
  useEffect(() => {
    void recarregar();
  }, [recarregar]);
  return { dados, erro, recarregar, definir };
}

/** Executa a gravação e mostra o resultado como aviso do sistema. */
export function useGravar() {
  const avisar = useEnvio((s) => s.avisar);
  const [gravando, definirGravando] = useState(false);
  const gravar = async (trabalho: () => Promise<unknown>, sucesso: string) => {
    definirGravando(true);
    try {
      await trabalho();
      avisar(sucesso);
      return true;
    } catch (e) {
      avisar((e as Error).message);
      return false;
    } finally {
      definirGravando(false);
    }
  };
  return { gravar, gravando };
}

export const somenteDigitos = (v: string) => v.replace(/\D/g, '');
export const ouNulo = (v: string | null | undefined) => (v && v.trim() ? v.trim() : null);
